import { datadogRumAddFeatureFlagEvaluation } from './datadogRumAddFeatureFlagEvaluation';
import { type LDInspectionFlagUsedHandler } from 'launchdarkly-js-client-sdk';

export const datadogInspector: LDInspectionFlagUsedHandler = {
  type: 'flag-used',
  name: 'dd-inspector',
  method: (flagKey, flagDetail) => {
    datadogRumAddFeatureFlagEvaluation(flagKey, flagDetail.value);
  },
};
